export const locale = {
	lang: 'it',
	data: {
		general: {
			pageNotFound: 'La pagina non esiste',
			unauthorized: 'Non hai i permessi per visualizzare la pagina',
			spinnerMessage: 'Caricamento pagina',
			loaderMessage: 'Caricamento ...',
			save: 'Salva',
			update: 'Aggiorna',
			requiredFields: 'Campi obbligatori',
			cancel: 'Annulla',
			search: 'Cerca',
			reset: 'Ripristina',
		},
		devices: {
			title: 'Dispositivi',
			confirmDisable: 'Vuoi disabilitare il dispositivo?',
			confirmEnable: 'Vuoi abilitare il dispositivo?',
			enabled: 'Abilitato',
			disabled: 'Disabilitato',
			confirmDelete: 'Vuoi eliminare questo dispositivo?',
			new: 'Crea un nuovo dispostivo',
			edit: 'Modifica del dispostivo',
			position: 'Posizione',
			uploadFromCsv: 'Carica i dispositivi da file CSV',
			uploadDevices: 'Carica',
			downloadExample: 'Scarica un esempio di file CSV',
			downloadDevices:'Scarica CSV',
			selectCsv: 'Seleziona un file CSV',
			select_location: 'Seleziona una location',
			success: {
				confirmDisable: 'Dispositivo disabilitato con successo',
				confirmEnable: 'Dispositivo abilitato con successo',
				confirmDelete: 'Dispositivo eliminato con successo',
				create: 'Dispositivo creato con successo',
				update: 'Dispositivo aggiornato con successo',
				upload: 'Dispositivi caricati con successo',
			},
			error: {
				devices: 'Non è stato possibile recuperare la lista dei dispositivi',
				device: 'Non è stato possibile recuperare il dispositivo',
				locations: 'Non è stato possibile recuperare la lista delle location',
				confirmDisable: 'Non è stato possibile disabilitare il dispositivo',
				confirmEnable: 'Non è stato possibile abilitare il dispositivo',
				confirmDelete: 'Si è verificato un errore durante l\'eliminazione del dispositivo',
				create: 'Non è stato possibile creare il dispositivo',
				update: 'Non è stato possibile aggiornare il dispositivo',
				unableRead: 'Impossibile leggere il file',
				unableReadCsv: 'Impossibile leggere il file CSV',
				upload: 'Si è verificato un errore durante il caricamento del file CSV',
				deviceExist:'Uno o più device è già esistente',
				download:'Si è verificato un errore durante il download del CSV'
			},
		},
		monitoring: {
			title: 'Monitoraggio',
			detail:'Dettaglio',
			confirmDisable: 'Vuoi disabilitare il monitoraggio del dispositivo?',
			confirmEnable: 'Vuoi abilitare il monitoraggio dispositivo?',
			count:'Dispositivi totali',
			online:'Dispositivi online',
			offline:'Dispositivi offline',
			pending:'Dispositivi pending',
			findStatus: 'Cerca per status',
			allStatus: 'Tutti gli status',
			error:{
				confirmDisable: 'Non è stato possibile disabilitare il dispositivo',
				confirmEnable: 'Non è stato possibile abilitare il dispositivo',
				counters: 'Non è stato possibile recuperare i valori di monitoraggio',
				allFields:'Assocurati di aver compilato la data e lo stato',
				confirmCSV:'Non è stato possibile scaricare il CSV'
			},
			success:{
				confirmDisable: 'Dispositivo disabilitato con successo',
				confirmEnable: 'Dispositivo abilitato con successo',
				confirmCSV:'File CSV scaricato con successo'
			},
			table:{
				timeline:'Giorni in cui il dispositivo si è collegato',
				log:'Log dispositivo in base allo stato',

			}
		},
		users: {
			title: 'Utenti',
			new: 'Crea nuovo utente',
			edit:'Modifica utente',
			confirmDelete:'Vuoi eliminare questo utente',
			success:{
				create:'Utente creato con successo',
				update:'Utente aggiornato con successo',
				confirmDelete:'Utente eliminato con successo',
			},
			error:{
				users: 'Non è stato possibile recuperare la lista degli utenti',
				user: 'Non è stato possibile recuperare l\'utente',
				create:'Errore durante la creazione dell\'utente',
				update:'Errore nell\'aggiornamento dell\'utente',
				confirmDelete:'Errore nell\' eliminazione dell\'utente',
			}
		},
		vpn: {
			title: 'Gestione VPN',
			new: 'Crea nuova VPN',
			edit:'Modifica VPN',
			confirmDelete:'Vuoi eliminare questa VPN',
			confirmDisable: 'Vuoi disabilitare la VPN?',
			confirmEnable: 'Vuoi abilitare la VPN',
			enabled: 'Abilitata',
			disabled: 'Disabilitata',
			subnet:'Subnet',
			ip:'IP',
			ipTip: 'Premere invio per confermare l\'inserimento dell\'indirizzo IP',
			success:{
				create:'VPN creata con successo',
				update:'VPN aggiornata con successo',
				confirmDelete:'VPN eliminata con successo',
				confirmDisable: 'Dispositivo VPN disabilitato con successo',
				confirmEnable: 'Dispositivo VPN abilitato con successo',
			},
			error:{
				subnet:'Formato subnet non valido',
				ip:'Formato IP non valido',
				vpn: 'Non è stato possibile recuperare la lista dei dispositivi VPN',
				create:'Errore durante la creazione della VPN',
				update:'Errore nell\'aggiornamento della VPN',
				confirmDelete:'Errore nell\' eliminazione della VPN',
				confirmDisable: 'Non è stato possibile disabilitare la gestione VPN',
				confirmEnable: 'Non è stato possibile abilitare la gestione VPN',
				data: "Controllare i dati inseriti. Il formato dell'IP non è valido oppure il campo nome è vuoto",
			}
		},
		table:{
			noData:'Nessun dato disponibile',
			uuid:'UUID',
			MAC:'MAC Address',
			name:'Nome',
			nasid:'Frazionario',
			ip:'IP',
			last_seen:'Data dell\'ultima rilevazione',
			last_seen_nasid:'Nasid dell\'ultima rilevazione',
			last_seen_location:'Location dell\'ultima rilevazione',
			location:'Location',
			status:'Stato',
			monitoring:'Monitoraggio',
			enabled: 'Abilitato',
			disabled: 'Disabilitato',
			actions: 'Azioni',
			edit: 'Modifica',
			show:'Vedi',
			delete: 'Elimina',
			date:'Data',
			log_message:'Log messaggio',
			first_name:'Nome',
			last_name:'Cognome',
			created_at:'Data creazione',
			role:'Ruolo',
			password:'Password',
			email:'Email',
			vpn:'VPN',
			select_role:'Seleziona ruolo',
		},
		status:{
			CLOSED: "Nessuno stato di connessione.",
			LISTEN: 'In attesa di una richiesta di connessione da qualsiasi TCP e porta remota.',
			SYN_SENT: 'In attesa di una richiesta di connessione corrispondente dopo aver inviato una richiesta di connessione.',
			SYN_RECEIVED: 'In attesa di una conferma di conferma della richiesta di connessione dopo aver ricevuto e inviato una richiesta di connessione.',
			ESTABLISHED: 'Una connessione aperta, i dati ricevuti possono essere consegnati all\'utente.',
			CLOSE_WAIT: 'In attesa di una richiesta di terminazione della connessione da parte dell\'utente locale.',
			FIN_WAIT_1: 'In attesa di una richiesta di terminazione della connessione dal TCP remoto o di un riconoscimento della richiesta di terminazione della connessione precedentemente inviata.',
			CLOSING: 'In attesa della conferma della richiesta di terminazione della connessione dal TCP remoto<',
			LAST_ACK: 'In attesa della conferma della richiesta di terminazione della connessione precedentemente inviata al TCP remoto (che non era ancora stata riconosciuta alla chiusura del socket)',
			FIN_WAIT_2: 'In attesa di una richiesta di terminazione della connessione dal TCP remoto.',
			TIME_WAIT: 'In attesa che passi abbastanza tempo per essere sicuri che il TCP remoto abbia ricevuto la conferma della sua richiesta di terminazione della connessione.',
			}
	}
}